import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["userId"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setSuccessAlert, setAlert } from 'actions/alerts';
import userEmailsKeys from './queryKeys';
export function useResendUserEmailVerification() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    userId = _ref.userId,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  function resendUserEmailVerification(_x) {
    return _resendUserEmailVerification.apply(this, arguments);
  }
  function _resendUserEmailVerification() {
    _resendUserEmailVerification = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(emailId) {
      var path;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            path = userId ? "/api/users/".concat(userId, "/email/").concat(emailId, "/resend") : "/api/me/email/".concat(emailId, "/resend");
            return _context.abrupt("return", api('post', path, null));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _resendUserEmailVerification.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: resendUserEmailVerification
    }, options), {}, {
      onSuccess: function onSuccess() {
        setSuccessAlert({
          title: t(userId ? 'alert_email_verification_resend_admin_success' : 'alert_email_verification_resend_success')
        });
        queryClient.invalidateQueries({
          queryKey: userEmailsKeys.userEmails(userId)
        });
      },
      onError: function onError() {
        setAlert({
          title: t('alert_email_verification_resend_error')
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    resendUserEmailVerification: mutateAsync
  });
}